/**
 * Test Data Helpers
 *
 * Utility functions for identifying and processing test data in the application.
 * Test products are identified by a "(Test N)" suffix in their titles.
 */

/**
 * Check if a product title indicates test data
 * Test products have "(Test N)" suffix where N is optional digits
 *
 * @example
 * isTestProduct("Sample Product (Test 1)") // true
 * isTestProduct("Sample Product (Test)") // true
 * isTestProduct("Regular Product") // false
 */
export function isTestProduct(title: string): boolean {
  return /\(Test\s*\d*\)/i.test(title);
}

/**
 * Remove test indicator from product title for display
 * Strips "(Test N)" suffix while preserving the rest of the title
 *
 * @example
 * cleanProductTitle("Sample Product (Test 1)") // "Sample Product"
 * cleanProductTitle("Sample Product (Test)") // "Sample Product"
 * cleanProductTitle("Regular Product") // "Regular Product"
 */
export function cleanProductTitle(title: string): string {
  return title.replace(/\s*\(Test\s*\d*\)/gi, '').trim();
}
